
import createIcon from "./createIcon";

export const MoreHorizontalIcon = createIcon('MoreHorizontal', (props) => {
  return (
    <svg {...props}>
      <g>
        <ellipse cx="4" cy="8" rx="1" ry="1" fill={props.color} fillOpacity="1" />
      </g>
      <g>
        <ellipse cx="8" cy="8" rx="1" ry="1" fill={props.color} fillOpacity="1" />
      </g>
      <g>
        <ellipse cx="12" cy="8" rx="1" ry="1" fill={props.color} fillOpacity="1" />
      </g>
    </svg >
  )
});
